/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * This object contains all parameters related to the location
 */
export interface StructureGroupLocation { 
    id?: number;
    /**
     * ID of the customers datatable to identify the building
     */
    externalId?: string;
    structureGroupName?: string;
    locX?: number;
    locY?: number;
    locZ?: number;
}

